<template>
    <layouts-header></layouts-header>
    <layouts-sidebar></layouts-sidebar>
    <div class="page-wrapper">
        <div class="content">
            <div class="row">
                <div class="col-md-12">
                    <!-- Page Header -->
                    <page-header :title="title" />
                    <!-- /Page Header -->

                    <!-- Settings Menu -->
                    <settings-tabs></settings-tabs>
                    <!-- /Settings Menu -->

                    <div class="row">
                        <!-- <website-sidebar></website-sidebar> -->

                        <div class="col-xl-12 col-lg-12">
                            <!-- Company Settings -->
                            <div class="card">
                                <div class="row card-body settings-form">
                                    <div class="col-md-6 mb-3 mb-md-0">
                                        <h4>Api Clicks</h4>
                                    </div>
                                    <div class="col-md-6 mb-4">
                                        <div class="export-csv text-sm-end">
                                            <div class="form-sorts ">
                                                <a class="me-2 export-link" :class="{ 'disabled-link': !hasData }"
                                                    @click.prevent="hasData && exportToCSV()">
                                                    <i class="ti ti-filter-share"></i> Export CSV
                                                </a>
                                                <a href="javascript:void(0);" data-bs-toggle="dropdown"
                                                    data-bs-auto-close="outside">
                                                    <i class="ti ti-filter-share"></i>Filter
                                                </a>
                                                <div class="filter-dropdown-menu dropdown-menu dropdown-menu-xl-end">
                                                    <div class="filter-set-view">
                                                        <div class="filter-set-head">
                                                            <h4><i class="ti ti-filter-share"></i>Filter</h4>
                                                        </div>
                                                        <div class="filter-content-list">

                                                            <label for="search-status" class="mb-2"> Start
                                                                Date - End Date</label>
                                                            <date-time-picker v-model="filters.date" range
                                                                :enable-time-picker="false" multi-calendars
                                                                format="yyyy-MM-dd" />

                                                        </div>

                                                        <div class="filter-content-list">
                                                            <label for="search-status" class="mb-2">API
                                                                Name</label>
                                                            <!-- <div class="form-wrap icon-form">
                                                                <span class="form-icon"><i
                                                                        class="ti ti-search"></i></span>
                                                                <input type="text" class="form-control"
                                                                    placeholder="Search Columns"
                                                                    v-model="filters.api_name" />
                                                            </div> -->

                                                            <div class="form-wrap icon-form">
                                                                <span class="form-icon"><i
                                                                        class="ti ti-search"></i></span>
                                                                <select v-model="filters.api_name" class="form-control">
                                                                    <option v-for="api in apiNameData" :key="api.value"
                                                                        :value="api.value">
                                                                        {{ api.text }}
                                                                    </option>
                                                                </select>
                                                            </div>

                                                        </div>
                                                        <div class="filter-content-list">
                                                            <label for="api-clicks-search-ref" class="mb-2">Lookup / MPAN</label>
                                                            <div class="form-wrap icon-form">
                                                                <span class="form-icon"><i class="ti ti-search"></i></span>
                                                                <input id="api-clicks-search-ref" type="text" class="form-control"
                                                                    placeholder="Search by reference…"
                                                                    v-model.trim="filters.search_reference"
                                                                    autocomplete="off" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="filter-content-list mb-4">
                                                        <label for="search-status" class="mb-2">User
                                                            Name</label>
                                                        <!-- <div class="form-wrap icon-form">
                                                            <span class="form-icon"><i class="ti ti-search"></i></span>
                                                            <select v-model="filters.user_id" class="form-control">
                                                                <option v-for="user in userData" :key="user.id"
                                                                    :value="user.id">
                                                                    {{ user.first_name }} {{ user.last_name ||
                                                                        '' }}
                                                                </option>
                                                            </select>
                                                        </div> -->
                                                        <div class="form-wrap icon-form">
                                                            <vue-select :options="userData" v-model="filters.user_id"
                                                                placeholder="Select....." :key="userData.id"
                                                                :id="userData.id" @select="myChangeEvent($event)"
                                                                autocomplete="off" autocorrect="off"
                                                                autocapitalize="off" spellcheck="false" />
                                                        </div>
                                                    </div>
                                                    <div class="filter-reset-btns">
                                                        <div class="row">
                                                            <div class="col-6">
                                                                <a href="javascript:void(0);" class="btn btn-light"
                                                                    @click="resetFilters">Reset</a>
                                                            </div>
                                                            <div class="col-6">
                                                                <a href="javascript:void(0);" class="btn btn-primary"
                                                                    @click="applyFilters">Filter</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="table-responsive custom-table">
                                        <api-clicks-table ref="apiClicksTable"
                                            :filters="appliedFilters"></api-clicks-table>
                                    </div>
                                    <div class="row align-items-center">
                                        <div class="col-md-6">
                                            <div class="datatable-length"></div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="datatable-paginate"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /Company Settings -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apiClient from '@/axios';
import { computed, nextTick, onMounted, ref } from 'vue';
import { useStore } from 'vuex';

export default {
    data() {
        return {
            title: "Settings",
            //   searchUserQuery: "",
        };
    },
    methods: {
        // async searchUsers() {
        //   this.$refs.apiClicksTable.fetchUsers();
        // },
    },

    setup() {
        const store = useStore();
        const filters = ref({
            date: null,
            api_name: '',
            user_id: '',
            search_reference: '',
        });
        const userData = ref([])
        const appliedFilters = ref({});

        const apiClicksTable = ref(null)

        const apiNameData = ref([])

        const fetchUsers = async () => {
            try {
                const params = {
                    allUsers: 1
                }
                const response = await store.dispatch('users/fetchUsers', params);
                if (response.status) {
                    // userData.value = response.data.data;
                    // const staticOption = {
                    //     id: '', // Ensure a unique ID for the static option
                    //     initials: 'No',
                    //     first_name: 'Select...',
                    //     last_name: '',
                    // };
                    userData.value = [
                        { id: 'null', text: 'Select....', original: null },
                        ...(Array.isArray(response.data?.data)
                            ? response.data.data.map(item => ({
                                id: item.id,
                                text: item.first_name + ' ' + (item.last_name === null ? ' ' : item.last_name)
                            }))
                            : [])
                    ];

                    // userData.value.unshift(staticOption);
                } else {
                    console.error("Failed to fetch users:", response);
                }
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };

        const fetchApiName = async () => {
            try {
                const response = await store.dispatch('users/fetchApiNames');
                if (response.status) {
                    apiNameData.value = response.data.dropdowns;
                    const staticOption = {
                        text: 'Select...',
                        value: ''
                    };
                    apiNameData.value.unshift(staticOption);
                } else {
                    console.error("Failed to fetch users:", response);
                }
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };


        const resetFilters = () => {
            filters.value = {
                date: null,
                api_name: '',
                user_id: '',
                search_reference: '',
            };
            applyFilters();
        };

        const filterApi = () => {
            if (apiClicksTable.value) {
                apiClicksTable.value.fetchAPIClicks();
            }
        };

        const applyFilters = () => {
            appliedFilters.value = { ...filters.value };
            // Wait for the filters to be applied, then fetch reports
            nextTick(() => {
                filterApi();
            });
        };

        const myChangeEvent = (event) => {
            if (event.id === 'null') {
                filters.value.user_id = '';
            }
        }

        const hasData = computed(() => {
            return apiClicksTable.value?.dataCount?.length > 0;
        });

        const exportToCSV = async () => {
            try {
                const f = appliedFilters.value;
                const params = {
                    start_date: formateDate(f?.date?.[0]),
                    end_date: formateDate(f?.date?.[1]),
                    api_name: f?.api_name,
                    user_id: f?.user_id,
                    ...(f?.search_reference ? { search_reference: f.search_reference } : {}),
                }
                const response = await apiClient.get('/company/export/api-clicks-csv', { params })
                if (response.data && response.data.data.url) {
                    const fileUrl = response.data.data.url;
                    const link = document.createElement("a");
                    link.href = fileUrl;
                    link.download = "";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    console.error("Error: Report download failed or no URL found.");
                }
            } catch (error) {
                console.error("Error during report download:", error);
            }
        }

        const formateDate = (dateString) => {
            let date
            if (dateString) {
                date = new Date(dateString);
                if (isNaN(date.getTime())) {
                    return null;
                }
                const yyyy = date.getFullYear();
                const mm = String(date.getMonth() + 1).padStart(2, '0');
                const dd = String(date.getDate()).padStart(2, '0');

                const formattedDate = `${yyyy}-${mm}-${dd}`;
                return formattedDate;
            }
        };

        onMounted(async () => {
            await fetchApiName();
            await fetchUsers();
            if (apiClicksTable.value) {
                apiClicksTable.value.fetchAPIClicks();
            }
        });

        return {
            filters,
            userData,
            fetchUsers,
            resetFilters,
            applyFilters,
            appliedFilters,
            apiClicksTable,
            filterApi,
            store,
            apiNameData,
            fetchApiName,
            myChangeEvent,
            exportToCSV,
            hasData
        }
    }
};
</script>
<style>
a.export-link {

    cursor: pointer;
    text-decoration: none;
    transition: opacity 0.3s ease;
}

a.export-link.disabled-link {
    pointer-events: none;
    opacity: 0.5;
    color: #999;
    cursor: not-allowed;
}
</style>